import { useEffect, useRef, useState } from "react";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import {
  Grid,
  GridCellProps,
  GridColumn,
  GridColumnMenuFilter,
  GridColumnMenuProps,
  GridDataStateChangeEvent,
  GridExpandChangeEvent,
  GridNoRecords,
} from "@progress/kendo-react-grid";

import {
  setExpandedState,
  setGroupIds,
} from "@progress/kendo-react-data-tools";
import { DataResult, process, State } from "@progress/kendo-data-query";
import { url } from "inspector";
import { SubmitStatus } from "../../core/formik-model-dialog.component";
import { API_END_POINT } from "../../constants";
import { GridCommandCell } from "../../core/grid-command-cell.component";
import { LoadingIndicator } from "../../core/loading-indicator.component";
import {
  DeleteModelDialog,
  DeletePostDataInfo,
  DeleteStatus,
} from "../../core/delete-model-dialog.component";
import {  useGetDroppingPoints } from "../../apiclient/party/useGetDropingPointApi";
import { GridActionComponent } from "../../core/action.title.component";
import DropingPointModel from "../../models/party/dropingpoint-model";
import CustomerEntry from "./customer-entry";

export const addOrUpdateArrayItem = (data: any[], item: any, key: string) => {
  const newData = data ? [...data] : [];
  const index = data?.findIndex((d) => d[key] === item[key]);
  console.log("the index is" + index);
  if (index > -1) {
    newData.splice(index, 1, item);
  } else {
    newData.push(item);
  }
  return newData;
};

const CustomerPage: React.FC = () => {
  const initialDataState: State = {
    take: 10,
    skip: 0,
    group: [],
  };
  const [dataState, setDataState] = useState<State>(initialDataState);
  const [deleteDropingPointData, setDeleteDropingPointData] =
    useState<DeletePostDataInfo>();
  const [collapsedState, setCollapsedState] = useState<string[]>([]);
  const [resultData, setResultData] = useState<DataResult>();

  const [editModal, setEditModal] = useState<boolean>(false);
  const [editData, setEditdata] = useState<DropingPointModel>(null);
  const exportExcel = useRef<ExcelExport | null>(null);

  const [pgreset, setpgreset] = useState<boolean>(false);
  const [viewModal, setViewModal] = useState<boolean>(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [droppingpointShow, setDroppingpointShow] = useState<boolean>(false);

  const {
    data: result,
    isLoading,
    isError,
    refetch: reloadDropingPoint,
  } = useGetDroppingPoints();

  const processWithGroups = (data: DropingPointModel[], dataState: State) => {
    const groups = dataState.group;
    dataState.group = groups;
    const newDataState = process(data, dataState);
    setGroupIds({ data: newDataState.data, group: dataState.group });
    return newDataState;
  };
  const fetchData = async () => {
    try {
      setIsRefreshing(true);
      const { data, error } = await reloadDropingPoint();
      if (error) {
        console.error("Error reloading:", error);
      } else {
        console.log("Reloaded data:", data);
      }
    } catch (err) {
      console.error("Unexpected error:", err);
    } finally {
      setIsRefreshing(false);
    }
  };

  useEffect(() => {
    setEditdata(null);
    fetchData();
    if (result) {
      setResultData(processWithGroups(result, initialDataState));
    }
  }, [result]);

  let newData: any = null;
  if (resultData) {
    newData = setExpandedState({
      data: resultData.data,
      collapsedIds: collapsedState,
    });
  }


  const onSaveComplete = (status: SubmitStatus, data: DropingPointModel) => {
    setEditdata(null);
    if (status === SubmitStatus.Completed) {
      reloadDropingPoint();
      setResultData(processWithGroups(newData, dataState));
    }
    setDroppingpointShow(false);
  };

  const excelExport = () => {
    if (exportExcel.current !== null) {
      exportExcel.current.save();
    }
  };

  const onAddNew = () => {
    setEditModal(true);
    setEditdata(new DropingPointModel());
    setDroppingpointShow(true)
  };
  const onView = (data: DropingPointModel) => {
    setViewModal(true);
    setEditdata(data);
    setDroppingpointShow(true);
  };
  const onEdit = (data: DropingPointModel) => {
    setEditModal(true);
    setViewModal(false);
    setEditdata(data);
    setDroppingpointShow(true);
  };

  const onRemove = (data: DropingPointModel) => {
    const { droppingpointId } = data;
    console.log(data);
    setDeleteDropingPointData({
      data,
      route: `DroppingPoint/DeleteDropingPoint/${droppingpointId}`,
      endpoint: API_END_POINT.PARTY,
    });
    reloadDropingPoint();
  };
  const onDeleteComplete = (status: DeleteStatus, data: DropingPointModel) => {
    if (status === DeleteStatus.Completed) {
      reloadDropingPoint();
      setResultData(processWithGroups(result, dataState));
    }
    setDeleteDropingPointData(null);
  };
  const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
      <div>
        <GridColumnMenuFilter {...props} expanded={true} />
      </div>
    );
  };

  const CommandCell = (props: GridCellProps) => (
    <GridCommandCell
      {...props}
      edit={onEdit}
      remove={onRemove}
      add={onAddNew}
      idPropertyName="id"
      editPermissionName={null}
      deletePermissionName={null}
      view={onView}

    />
  );

  const onSearch = (e: any) => {
    if (e.target.value.length > 0) {
      const searchKey: string = e.target.value;
      const filteredData = result?.filter(
        (p) =>
          p?.code?.toLowerCase().includes(searchKey?.toLowerCase()) ||
          p?.name?.toLowerCase().includes(searchKey?.toLowerCase())
      );
      setResultData(process(filteredData, dataState));
    } else {
      setResultData(process(result, dataState));
    }
  };

  const expandChange = (event: GridExpandChangeEvent) => {
    const item = event.dataItem;

    if (item.groupId) {
      const newCollapsedIds = !event.value
        ? [...collapsedState, item.groupId]
        : collapsedState.filter((groupId) => groupId !== item.groupId);
      setCollapsedState(newCollapsedIds);
    }
  };

  const ColumnFormatBoolean = (props: any) => {
    return (
      <td
        {...props.tdProps}
        colSpan={1}
        style={{
          color: "black",
        }}
      >
        {props.children === "true" ? (
          <span style={{ color: "green", fontWeight: "bold" }}>Yes</span>
        ) : (
          <span style={{ color: "red", fontWeight: "bold" }}>No</span>
        )}
      </td>
    );
  };
  const refreshGrid = () => {
    reloadDropingPoint();
  };
  const dataStateChange = (event: GridDataStateChangeEvent) => {
    const newDataState = processWithGroups(result, event.dataState);
    setResultData(newDataState);
    setDataState(event.dataState);
  };
  const onAddClick = () => {
    setEditModal(true);
    setViewModal(false);
    setEditdata(new DropingPointModel());
  };
  let grid = null;
  if (result) {
    grid = (
      <Grid
        data={newData}
        pageable={{ pageSizes: [10, 20, 50, 100] }}
        total={resultData?.total}
        groupable={true}
        sortable={true}
        onDataStateChange={dataStateChange}
        {...dataState}
        onExpandChange={expandChange}
        columnVirtualization={false}
        resizable={true}
      >
        {/* <GridToolbar className="export-bg">
       
        </GridToolbar> */}
        <GridColumn
          field="code"
          title="Code"
          columnMenu={ColumnMenu}
        />

        <GridColumn
          field="name"
          title="Name"
          columnMenu={ColumnMenu}
        />
        <GridColumn
          field="address"
          title="Address"
        // columnMenu={ColumnMenu}
        />

        {/* <GridColumn
          width={"280px"}
          field="type"
          title="Type"
          // columnMenu={ColumnMenu}
        /> */}

        <GridColumn field="firstName" title="Agent Name" />

        <GridColumn
          field="isOtherState"
          title="Other State"
          cells={{ data: ColumnFormatBoolean }}
        />
        <GridColumn
          field="isActive"
          title="Active ?"
          cells={{ data: ColumnFormatBoolean }}
        />

        <GridColumn
          cell={CommandCell}
          title="Action"
          width={"150"}
          groupable={true}
        />

        <GridNoRecords>
          <div className="mt-2" style={{ width: "100%", height: "500px" }}>
            <center>
              <h5>No data found</h5>
            </center>
          </div>
        </GridNoRecords>
      </Grid>
    );
    if (isError) {
      return (
        <div>
          <h4>Error Loadong Page..</h4>
        </div>
      );
    }

    return (
      <>

        <div
          style={{ minHeight: "600px" }}
          className="card p-3 border-0 m-3 sw-shadow radius-15"
        >

          <div>
            <GridActionComponent
              onSearchClick={onSearch}
              addButtonClick={onAddClick}
              excelExportClick={excelExport}
              refreshClick={fetchData}
              title="CUSTOMER"
              addButtonTooltip="Add Customer"
            ></GridActionComponent>
          </div>
          {editModal && (
            <CustomerEntry isViewMode={viewModal} data={editData} onClose={onSaveComplete} />
          )}
          {viewModal && (
            <CustomerEntry
              isViewMode={true}
              data={editData}
              onClose={onSaveComplete}
            />
          )}
          {deleteDropingPointData && (
            <DeleteModelDialog
              title="Delete Customer"
              deleteData={deleteDropingPointData}
              onClose={onDeleteComplete}
            >
              <div>
                Are you sure you want to delete Customer:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {deleteDropingPointData.data.name}
                </span>
                ?
              </div>
            </DeleteModelDialog>
          )}

          <div>
            <>
              {isRefreshing || isLoading ? (
                <LoadingIndicator isLoading={isRefreshing}></LoadingIndicator>
              ) : (
                <div>
                  {grid}
                  <ExcelExport
                    fileName={"Customer_Page"}
                    data={result}
                    ref={exportExcel}
                  >
                    <ExcelExportColumn width={100} field="code" title="Code #" />

                    <ExcelExportColumn width={150} field="name" title="Name" />
                    <ExcelExportColumn
                      width={170}
                      field="address"
                      title="Address"
                    />
                    <ExcelExportColumn
                      width={150}
                      field="pincode"
                      title="Pincode"
                    />
                    <ExcelExportColumn
                      width={150}
                      field="landmark"
                      title="Landmark"
                    />
                    <ExcelExportColumn
                      width={280}
                      field="firstName"
                      title="Agent Name"
                    />
                    <ExcelExportColumn
                      width={280}
                      field="morningRouteName"
                      title="Morning Route Name   "
                    />
                    <ExcelExportColumn
                      width={280}
                      field="morningRouteOrder"
                      title="Morning Route Order  "
                    />
                    <ExcelExportColumn
                      width={280}
                      field="eveningRouteName"
                      title="Evening Route Name   "
                    />
                    <ExcelExportColumn
                      width={280}
                      field="eveningRouteOrder"
                      title="Evening Route Order   "
                    />
                    <ExcelExportColumn
                      width={280}
                      field="areaName"
                      title="Area Name   "
                    />
                    <ExcelExportColumn
                      width={280}
                      field="latitude"
                      title="Latitude"
                    />
                    <ExcelExportColumn
                      width={280}
                      field="longitude"
                      title="Longitude"
                    />
                    <ExcelExportColumn
                      width={280}
                      field="constituencyName"
                      title="Constituency Name   "
                    />
                    <ExcelExportColumn
                      width={280}
                      field="wardName"
                      title="Ward Name   "
                    />
                    <ExcelExportColumn
                      width={280}
                      field="zoneName"
                      title="Zone Name   "
                    />
                    <ExcelExportColumn
                      width={280}
                      field="districtName"
                      title="District Name   "
                    />
                    <ExcelExportColumn
                      width={280}
                      field="stateName"
                      title="State Name   "
                    />
                    <ExcelExportColumn
                      width={280}
                      field="talukName"
                      title="Taluk Name   "
                    />
                    <ExcelExportColumn
                      width={280}
                      field="unionName"
                      title="Union Name   "
                    />
                    <ExcelExportColumn
                      width={280}
                      field="minimumOrderQuantity"
                      title="Minimum Order Quantity"
                    />
                    <ExcelExportColumn
                      width={280}
                      field="maximumOrderQuantity"
                      title="Maximum Order Quantity"
                    />
                    <ExcelExportColumn
                      width={280}
                      field="creditLimit"
                      title="Credit Limit"
                    />
                    <ExcelExportColumn
                      width={100}
                      field="accountCode"
                      title="Account Code"
                    />
                       <ExcelExportColumn
                      width={100}
                      field="isActive"
                      title="Active"
                    />
                    <ExcelExportColumn
                      width={100}
                      field="isOtherState"
                      title="Other State"
                    />

                  </ExcelExport>
                </div>
              )}

            </>
          </div>
          <div></div>
        </div>
      </>
    );
  }
};
export default CustomerPage;
